import { parseAutoImageId } from '@dispositio/core';
import { useEffect, type ImgHTMLAttributes } from 'react';
import { getAssetData, loadAsset, useAssetVersion } from '../lib/assets';

/** Durchsichtiges Pixel, bis ein automatisches Bild erzeugt ist */
const BLANK = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

/**
 * Bild eines Objekts (Kennung aus core `imageIdOf`): hochgeladene Bilder vom Server, automatische (`auto:…`) im Browser erzeugt
 * (lib/assets).
 */
export function AssetImg({ id, ...rest }: { id: string } & Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'>) {
  useAssetVersion();
  const parsed = parseAutoImageId(id);
  const auto = parsed !== null;
  const data = auto ? getAssetData(id) : null;
  useEffect(() => {
    if (auto && !data) loadAsset(id);
  }, [auto, data, id]);
  return (
    <img
      {...rest}
      src={auto ? (data ?? BLANK) : `/api/assets/${id}`}
      data-auto-image={parsed?.template}
    />
  );
}
